
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  public tabbars = [
    {
      name: "首页",
      routerName: "/home",
      icon: require("@/assets/icons/home.png"),
      active: require("@/assets/icons/home-active.png"),
    },
    {
      name: "订单",
      routerName: "/order",
      icon: require("@/assets/icons/order.png"),
      active: require("@/assets/icons/order-active.png"),
    },
    {
      name: "我的",
      routerName: "/my",
      icon: require("@/assets/icons/my.png"),
      active: require("@/assets/icons/my-active.png"),
    },
  ];
  public showNav = false;

  public mounted() {
    const obj: any = this.$fn.parseQuery(window.location.href);
    if (obj.device && obj.device == "ios" && this.$route.path == "/order") {
      this.showNav = false;
    }
    if (
      this.$fn.cookies.getIsios() &&
      this.$fn.cookies.getIsios() == "ios" &&
      this.$route.path == "/order"
    ) {
      this.showNav = false;
    }
  }
}
